import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recentlyViewed: [],
  maxItems: 10,
};

const rentSmallSmallRecentlyViewedSlice = createSlice({
  name: 'rentSmallSmallRecentlyViewed',
  initialState,
  reducers: {
    addItemToRecentlyViewed(state, action) {
      const newProperty = action.payload;
      const filteredItems = state.recentlyViewed.filter(
        (item) => item.propertyID !== newProperty.propertyID
      );
      const updatedItems = [newProperty, ...filteredItems].slice(
        0,
        state.maxItems
      );
      state.recentlyViewed = updatedItems;
    },
    clearRecentlyViewed(state) {
      state.recentlyViewed = [];
    },
  },
});

export const { addItemToRecentlyViewed, clearRecentlyViewed } =
  rentSmallSmallRecentlyViewedSlice.actions;

// Selector: use the key you register in your store, e.g. rentSmallSmallRecentlyViewed
export const getRecentlyViewedProperties = (state) =>
  state.rentSmallSmallRecentlyViewed?.recentlyViewed;

export default rentSmallSmallRecentlyViewedSlice.reducer;
